module.exports = __webpack_public_path__ + "static/media/machine-img-h.0d1d469c.png";